import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import EditIcon from '@material-ui/icons/Edit';
import TextField from '@material-ui/core/TextField';
import { withSnackbar } from 'notistack';
import { Image } from 'cloudinary-react';

import css from './Heading.module.scss';
import handleServerError from '../../../lib/functions/handleServerError';
import toJS from '../../../lib/hocs/toJS';
import { homePath } from '../../../lib/constants/links';

const styles = (theme) => ({
  headingTextContainer: {
    maxWidth: 800,
    marginLeft: 16,
  },
  headingText: {
    [theme.breakpoints.down('xs')]: {
      fontSize: 40,
    },
  },
  subheadingText: {
    // padding: 8,
    color: 'white',
  },
});

class Heading extends Component {
  constructor(props, context) {
    super(props, context);

    this.state = this.initialState();
  }

  componentWillReceiveProps(nextProps) {
    if (!this.props.isEditingOrganization && nextProps.isEditingOrganization) {
      this.setState(this.initialState());
    }
  }

  initialState = () => ({
    isEditingName: false,
    isEditingSubheading: false,
    name: this.props.organization.name,
    subheading: this.props.organization.subheading,
    isSaving: false,
  });

  handleSave = (key, e = null) => {
    e.preventDefault();
    this.setState({ isEditingName: false, isEditingSubheading: false });
    if (this.state[key] === this.props.organization[key] || this.state.isSaving)
      return;
    this.setState({ isSaving: true });
    const organization = { [key]: this.state[key] };
    this.props
      .onUpdateOrganization(organization)
      .then(() => this.setState({ isSaving: false }))
      .catch((error) => {
        this.setState({ isSaving: false });
        handleServerError(error, [], this.props.enqueueSnackbar);
      });
  };

  renderHeadingText() {
    const { classes, isEditingOrganization } = this.props;
    return (
      <div className={classes.headingTextContainer}>
        <div>
          <hr className={css.hr} />
          {isEditingOrganization && this.state.isEditingName ? (
            <form onSubmit={(e) => this.handleSave('name', e)}>
              <TextField
                value={this.state.name}
                onBlur={(e) => this.handleSave('name', e)}
                onChange={(e) => this.setState({ name: e.target.value })}
                autoFocus
                variant="outlined"
                className={css.editOrgName}
              />
            </form>
          ) : (
            <Typography
              variant="h3"
              className={`${classes.headingText} ${css.headingText}`}
              onClick={() =>
                isEditingOrganization && this.setState({ isEditingName: true })
              }
              style={{ color: 'white', cursor: 'pointer' }}
            >
              <span>{this.state.name}</span>
              {isEditingOrganization && (
                <span className={css.editOrgNameSpan}>
                  <EditIcon className={css.editNameIcon} />
                </span>
              )}
            </Typography>
          )}
          <hr className={css.hr} />
        </div>
        <div>
          {isEditingOrganization && this.state.isEditingSubheading ? (
            <form onSubmit={(e) => this.handleSave('subheading', e)}>
              <TextField
                autoFocus
                value={this.state.subheading}
                onChange={(e) => this.setState({ subheading: e.target.value })}
                onBlur={(e) => this.handleSave('subheading', e)}
                variant="outlined"
                className={css.editOrgName}
              />
            </form>
          ) : (
            <Typography
              variant="subtitle1"
              className={css.subheadingText}
              onClick={() =>
                isEditingOrganization &&
                this.setState({ isEditingSubheading: true })
              }
              style={{ color: 'white', cursor: 'pointer' }}
            >
              <span>{this.state.subheading}</span>
              {isEditingOrganization && (
                <span className={css.editOrgSubheadingSpan}>
                  <EditIcon className={css.editSubheadingIcon} />
                </span>
              )}
            </Typography>
          )}
        </div>
      </div>
    );
  }

  renderHeadingImage() {
    const { organization } = this.props;
    return (
      <Image
        publicId={organization.header_filename}
        height="150"
        width="1130"
        crop="scale"
        alt="heading"
        style={{ margin: 'auto', maxWidth: '100%', height: 'auto' }}
      />
    );
  }

  render() {
    const { organization, isEditingOrganization } = this.props;
    return organization.show_header ? (
      <div style={{ margin: 'auto' }}>
        <a href={homePath}>{this.renderHeadingImage()}</a>
      </div>
    ) : (
      <div>
        {isEditingOrganization ? (
          this.renderHeadingText()
        ) : (
          <a href={homePath} style={{ textDecoration: 'none' }}>
            {this.renderHeadingText()}
          </a>
        )}
      </div>
    );
  }
}

Heading.propTypes = {
  classes: PropTypes.object.isRequired,
  enqueueSnackbar: PropTypes.func.isRequired,
  isEditingOrganization: PropTypes.bool.isRequired,
  onUpdateOrganization: PropTypes.func.isRequired,
  organization: PropTypes.object.isRequired,
};
Heading.defaultProps = {};

export default toJS(withStyles(styles)(withSnackbar(Heading)));
